var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAi3Opsz24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 13.97",
    fill: "#909090",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ai3_FILL0_wght400_GRAD0_opsz24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.54,18.75h-2a.88.88,0,0,1-.55-.17.86.86,0,0,1-.31-.42l-1.05-2.85H6.83l-1,2.85a.89.89,0,0,1-.86.59h-2l5.49-14h2.66Zm-9-5.27H12l-1.7-4.65c-.07-.21-.16-.45-.25-.73s-.19-.59-.28-.91l-.26.91c-.09.29-.18.53-.26.75Z",
    transform: "translate(-2.91 -4.78)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.91,18.75H18.3v-14h2.61Z",
    transform: "translate(-2.91 -4.78)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi3Opsz24);
export default __webpack_public_path__ + "static/media/ai3_opsz24.323b86ea76d8ca575eea8a4d978dfff0.svg";
export { ForwardRef as ReactComponent };